(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(() => {
  const updateTableFocus = (region) => {
    const overflows = region.scrollWidth > region.clientWidth + 1;
    if (overflows && !region.hasAttribute('tabindex')) {
      region.setAttribute('tabindex', '0');
      region.dataset.ntArticleTableTabindexAdded = 'true';
    } else if (!overflows && region.dataset.ntArticleTableTabindexAdded === 'true') {
      region.removeAttribute('tabindex');
      delete region.dataset.ntArticleTableTabindexAdded;
    }
  };

  const tableResizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const region = entry.target.closest('.nt-article-table-scroll');
        if (region) updateTableFocus(region);
      });
    })
    : null;

  const tableText = (element) => (element?.textContent || '').replace(/\s+/g, ' ').trim();

  const enhanceArticleTables = (scope) => {
    scope.querySelectorAll('.article-template__content').forEach((content) => {
      const headings = Array.from(content.querySelectorAll('h2, h3, h4, h5, h6'));
      content.querySelectorAll('table').forEach((table) => {
        if (table.closest('.nt-article-table-scroll')) return;
        let region = table.closest('.table-responsive, .table-wrapper');
        if (!region || !content.contains(region)) {
          region = document.createElement('div');
          region.dataset.ntArticleTableCreated = 'true';
          table.before(region);
          region.append(table);
        }
        region.classList.add('nt-article-table-scroll');
        if (!region.hasAttribute('role')) region.setAttribute('role', 'region');
        if (!region.getAttribute('aria-label') && !region.getAttribute('aria-labelledby')) {
          const heading = headings.filter((item) =>
            item.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING
          ).pop();
          const title = content.closest('.article-template')?.querySelector('.article-template__title');
          const label = tableText(table.caption) || tableText(heading) || tableText(title) || document.title;
          region.setAttribute('aria-label', label);
        }
        updateTableFocus(region);
        tableResizeObserver?.observe(region);
        tableResizeObserver?.observe(table);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceArticleTables(document), { once: true });
  } else {
    enhanceArticleTables(document);
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll('.nt-article-table-scroll').forEach(updateTableFocus);
  });

  document.addEventListener('shopify:section:load', (event) => enhanceArticleTables(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.nt-article-table-scroll').forEach((region) => {
      tableResizeObserver?.unobserve(region);
      region.querySelectorAll('table').forEach((table) => tableResizeObserver?.unobserve(table));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
